export function SET_ALERT_SUCCESS(state, payload) {
  state;
  state.value = payload.results.value;
  state.color = payload.results.color;
  state.message = payload.results.message;
}
